import React from 'react';
import { ArrowRight, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-navy pt-12 pb-20 px-4 md:pt-20 md:pb-32 overflow-hidden" data-id="element-74">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-grid-pattern bg-[size:40px_40px] opacity-20 pointer-events-none" data-id="element-75" />
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-cyan/10 blur-[120px] rounded-full pointer-events-none" data-id="element-76" />
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-gold/5 blur-[100px] rounded-full pointer-events-none" data-id="element-77" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-78">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-79">
          {/* Text Content */}
          <div className="flex flex-col space-y-6 text-center lg:text-left" data-id="element-80">
            <div className="inline-block mx-auto lg:mx-0" data-id="element-81">
              <span className="bg-cyan/10 text-cyan border border-cyan/30 px-4 py-1.5 rounded-full text-sm font-bold tracking-wider uppercase" data-id="element-82">
                Para padres con hijos de 8 a 16 años
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-headline font-bold leading-tight text-white uppercase" data-id="element-83">
              El talento de tu hijo es real, pero en el sistema de EE.UU.,{' '}
              <span className="text-danger" data-id="element-84">eso NO es suficiente</span> para que
              lo vean.
            </h1>

            <p className="text-xl md:text-2xl text-gold font-medium leading-relaxed" data-id="element-85">
              Cómo hackear el muro del "Pay-to-Play" y poner a tu hijo frente a
              los Scouts de Clubes Premier y Colleges sin gastar $5,000 en
              academias que solo quieren tu mensualidad.
            </p>

            <div className="pt-4 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-86">
              <button onClick={() => window.open('https://ebookdigital.digital//cart/47440735863033:1', '_blank')} className="bg-gold hover:bg-gold-light text-navy-light font-headline font-bold text-xl px-8 py-4 rounded-lg shadow-[0_0_20px_rgba(245,166,35,0.4)] transition-all transform hover:scale-105 flex items-center justify-center gap-2 uppercase" data-id="element-87">
                ¡Quiero el acceso inmediato!
                <ArrowRight className="w-6 h-6" data-id="element-88" />
              </button>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-2 text-muted text-sm" data-id="element-89">
              <div className="flex text-gold" data-id="element-90">
                <Star className="w-4 h-4 fill-current" data-id="element-91" />
                <Star className="w-4 h-4 fill-current" data-id="element-92" />
                <Star className="w-4 h-4 fill-current" data-id="element-93" />
                <Star className="w-4 h-4 fill-current" data-id="element-94" />
                <Star className="w-4 h-4 fill-current" data-id="element-95" />
              </div>
              <span data-id="element-96">Método probado por padres reales</span>
            </div>
          </div>

          {/* Image Content */}
          <div className="relative mx-auto w-full max-w-[600px] lg:max-w-none" data-id="element-97">
            <div className="relative rounded-xl overflow-hidden border border-cyan/30 shadow-[0_0_40px_rgba(0,212,255,0.15)] group" data-id="element-98">
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-transparent opacity-40 z-10" data-id="element-99" />
              <img src="https://cdn.magicpatterns.com/uploads/aTULEuY6AzG7d7F5tXSpqf/el_mapa_del_tesoro_2.png" alt="El Mapa del Tesoro - Método Beca Pro" className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105" data-id="element-100" />

              {/* Floating Badge */}
              <div className="absolute bottom-6 right-6 z-20 bg-navy/90 border border-gold/50 backdrop-blur-md px-4 py-3 rounded-lg shadow-lg" data-id="element-101">
                <p className="text-gold font-headline font-bold text-lg leading-none" data-id="element-102">
                  Ruta Crítica
                </p>
                <p className="text-white text-xs uppercase tracking-widest" data-id="element-103">
                  Edición 8-16 Años
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}